@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.errorMessage {
  position: absolute;
  color: v.$error-color;
  bottom: -22px;
  @include t.text(12px, 20px, "medium");
}
